import { css } from '@/styled-system/css';

export const accordionPanelStyles = css.raw({
  display: 'block',
  position: 'relative',
  paddingInline: 'Accordion.Panel.padding.horz',
  paddingBlockStart: 'Accordion.Panel.padding.top',
  paddingBlockEnd: 'Accordion.Panel.padding.bottom',
  borderTopWidth: 'Accordion.default',
  borderTopStyle: 'solid',
  borderTopColor: 'Accordion.Panel.border',
  backgroundColor: 'Accordion.Panel.bg',
  borderBottomLeftRadius: 'Accordion.default',
  borderBottomRightRadius: 'Accordion.default',
});
